import Head from "next/head";
import { make as UnitInfoPage } from "../../../src/info/UnitInfoPage.bs";
import { lastPatch } from "common/src/Config.ts";
import { units as unitsT } from "common/src/bindings/Translation2.ts";
import { fromUrlName } from "common/src/tft-static/Sd.ts";

export default function UnitsInfo({ unitId, topItems }) {
  return (
    <>
      <Head>
        <title>{`${unitsT(unitId)} Set 14 TFT Info & Best Item Build`}</title>
      </Head>
      <UnitInfoPage set={140} unitId={unitId} topItems={topItems} />
    </>
  );
}

export function getStaticPaths() {
  return { paths: [], fallback: "blocking" };
  // return {
  //   paths: locales
  //     .map((locale) =>
  //       all.map((u) => ({
  //         params: {
  //           unitName: toUrlName(u),
  //         },
  //         locale,
  //       }))
  //     )
  //     .flat(),
  //   fallback: false,
  // };
}

export async function getStaticProps({ params }) {
  const { unitName } = params;
  const unitId = fromUrlName(unitName, 140);
  if (unitId == null) {
    return {
      notFound: true,
    };
  }

  let topItems = [];
  try {
    const resp = await fetch(`https://api.tft.tools/general/1/${lastPatch}`);
    const data = await resp.json();
    topItems = data.units[unitId] ? data.units[unitId].topItems : [];
  } catch (err) {}

  return {
    props: {
      unitId,
      topItems,
    },
  };
}
